import styled from '@emotion/styled';
import { alpha } from '@mui/system';

import { hoverable } from '@/design-system';
import { forMobile } from '@/design-system/responsive';
import { typographyVariantStyles } from '@/design-system/typography-variants';

export const StyledFooter = styled('footer')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: theme.colors.background.default,
  padding: '12px 18px',
  flexWrap: 'wrap',
  gap: 16,

  [forMobile]: {
    flexDirection: 'column',
    gap: 24,
  },
}));

export const FooterNavigation = styled('nav')({
  display: 'flex',
  alignItems: 'center',
});

export const FooterMenu = styled('ul')({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  padding: 0,
  margin: 0,

  [forMobile]: {
    flexDirection: 'column',
  },
});

export const FooterMenuItem = styled('li')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: 14,

  'div[role="separator"]': {
    [forMobile]: {
      display: 'none',
    },
  },
});

export const FooterMenuLink = styled('a')(({ theme }) => ({
  ...hoverable(theme, 'text'),
  ...typographyVariantStyles.body3,
  color: alpha(theme.colors.text.primary, 0.4),
  textDecoration: 'none',
}));

export const FooterSection = styled('section')({
  display: 'flex',
  alignItems: 'center',
  gap: 12,

  'div[role="separator"]': {
    height: 14,
    alignSelf: 'center',

    [forMobile]: {
      display: 'none',
    },
  },

  [forMobile]: {
    flexDirection: 'column',
  },
});

export const FooterContacts = styled('address')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 7,
  fontStyle: 'initial',

  svg: {
    color: theme.colors.icon.brand,
  },
}));

export const FooterSocials = styled('ul')({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  padding: 0,
  margin: 0,

  li: {
    display: 'flex',
  },
});

export const FooterSocialLink = styled('a')(({ theme }) => ({
  ...hoverable(theme, 'surfaceRaised'),
  width: 24,
  height: 24,
  borderRadius: '50%',
  border: `1px solid ${theme.colors.border.default}`,
  backgroundColor: theme.colors.background.raised,

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const FooterStatus = styled('div')(({ theme }) => ({
  padding: '4px 8px',
  borderRadius: '22px',
  border: `1px solid ${theme.colors.border.default}`,
  backgroundColor: theme.colors.background.raised,

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 2,
}));
